<script lang="ts">
    import {afterUpdate} from "svelte";
    import {toBytes} from "$lib/utils/fileSizeConverter";
    import Dropzone from "svelte-file-dropzone";

    export let allowedSize = '20KB';
    export let allowedFiles = ['PDF', 'PNG', 'JPG']

    export let existingImage = null;

    export let extract = (accepted, rejected) => {

    }

    let files = {
        accepted: [],
        rejected: []
    };

    $: accept = allowedFiles.map(x => {
        let mime;
        switch(x.toLowerCase()){
            case 'jpg':
            case 'jpeg': mime = 'image/jpeg'; break;
            case 'gif': mime = 'image/gif'; break;
            case 'png': mime = 'image/png'; break;
            case 'json':  mime =  'application/json'; break;
            case 'pdf':  mime =  'application/pdf'; break;
            case 'doc':  mime =  'application/msword'; break;
            case 'docx':  mime =  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'; break;
            case 'xls':  mime =  'application/vnd.ms-excel'; break;
            case 'xla':  mime =  'application/vnd.ms-excel'; break;
            case 'xlsx':  mime =  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; break;
            case 'dotx':  mime =  'application/vnd.openxmlformats-officedocument.wordprocessingml.template'; break;
            case 'ppt':  mime =  'application/pdf'; break;
            case 'pptx':  mime =  'application/vnd.openxmlformats-officedocument.presentationml.presentation.potx'; break;
        }
        return mime;
    }).join(', ')


    function handleFilesSelect(e) {
        const { acceptedFiles, fileRejections } = e.detail;
        console.log({e});
        //existingImage = acceptedFiles[0].type.startsWith('image') ? URL.createObjectURL(acceptedFiles[0]) : null;
        files.accepted = [...files.accepted, ...acceptedFiles];
        files.rejected = [...files.rejected, ...fileRejections];
        extract(files.accepted, files.rejected);
        files = {
            accepted: [],
            rejected: []
        };
    }

</script>
<Dropzone maxSize={toBytes(allowedSize)} {accept} disableDefaultStyles on:change={handleFilesSelect} on:drop={handleFilesSelect}>
    <div  class="mt-2 flex justify-center rounded-lg border border-dashed border-gray-900/25 px-6 py-10 bg-gray-50">
        <div class="text-center">
            {#if existingImage}
                <img alt="" src={existingImage} >
            {:else}
                <svg class="mx-auto h-12 w-12 text-gray-300" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z" clip-rule="evenodd" />
                </svg>
            {/if}

            <div class="mt-4 flex flex-col items-center text-sm leading-6 text-gray-600">
                <p class="relative cursor-pointer rounded-md bg-white font-semibold text-primary-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-primary-600 focus-within:ring-offset-2 hover:text-primary-500">
                    Datei auswählen
                </p>
                <p class="pl-1">oder Drag&Drop</p>
            </div>
            <p class="text-xs leading-5 text-gray-600">{allowedFiles.join(', ').toUpperCase()} bis zu {allowedSize}</p>
        </div>
    </div>
</Dropzone>